import React, { useMemo, useCallback } from 'react'

import {
  Modal,
  Checkbox,
} from  '../../../components'

import useModel from '../../../common/useModel'

import S from './copyVariationModalStyled.js'

const defaultModel = {
  values: {
    selected: null,
    selectedToCopy: null,
  },
}

const CopyApplianceModal = ({ appliances, usedAppliances, locales, onChange, onClose, defaultLocale }) => {

  const { checkbox, values, onChange: changeModel } = useModel(defaultModel)

  const handleConfirm = useCallback(() => {
    onChange({
      appliance: appliances.find(a => a.id === values.selected),
      ...(values.copy ? ({
        applianceToCopy: usedAppliances[values.selectedToCopy],
      }): null),
    })
  }, [appliances, onChange, usedAppliances, values.copy, values.selected, values.selectedToCopy])


  const actions = useMemo(() => {
    return [{
      title: 'Cancel',
      action: onClose,
      blue: true,
      outlined: true,
    }, {
      title: 'Confirm',
      action: handleConfirm,
      blue: true,
      disabled: !values.selected || (values.selected && values.copy && values.selectedToCopy === null),
    }]
  }, [onClose, handleConfirm, values.selected, values.copy, values.selectedToCopy])

  const freeAppliances = useMemo(() => {
    const used = Reflect.ownKeys(usedAppliances).map(aId => parseInt(aId, 10))
    return appliances.filter(a => !used.includes(a.id))
  }, [appliances, usedAppliances])

  const existingAppliances = useMemo(() => {
    const used = Reflect.ownKeys(usedAppliances).map(aId => parseInt(aId, 10))
    return appliances.map(a => used.includes(a.id) ? a : null).filter(Boolean)
  }, [appliances, usedAppliances])

  return (
    <Modal isOpened actions={actions} padding={'10px 20px'} flexRow>
      <S.ModalContent>
        <S.Title>Add Appliance</S.Title>
        <S.Existing className={!values.copy ? 'disabled' : ''}>
          {
            freeAppliances.map((appliance, index) => (
              <S.ExistingItem
                key={`appliance_${index}`} className={values.selected === appliance.id ? 'selected' : null}
                onClick={() => changeModel({ target: {
                  name: 'values.selected',
                  value: appliance.id,
                } })}
              >
                {appliance.description}
              </S.ExistingItem>
            ))
          }
        </S.Existing>

        <div style={{ marginTop: 20 }}/>
        <Checkbox {...checkbox({
          name: 'values.copy',
          title: 'Copy existing appliance steps',
        })}/>

        {
          values.copy && <S.Existing className={!values.copy ? 'disabled' : ''}>
            {
              existingAppliances.map((appliance, index) => (
                <S.ExistingItem
                  key={`appliance_${index}`} className={values.selectedToCopy === appliance.id ? 'selected' : null}
                  onClick={() => changeModel({ target: {
                    name: 'values.selectedToCopy',
                    value: appliance.id,
                  } })}
                >
                  {appliance.description}
                </S.ExistingItem>
              ))
            }
          </S.Existing>
        }

      </S.ModalContent>
    </Modal>
  )
}

export default CopyApplianceModal
